import axios from 'axios';

if (window.sessionStorage.getItem('token')) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('token');
}

export default axios;